export enum RequestActionEnum {
  APPROVE = 'approve',
  REJECT = 'reject',
  REASSIGN = 're_assign',
  SENDBACK = 'send_back',
  SENDFORWARD = 'send_forward',
  SAVE = 'save', // Not dynamic as the rest actions
  COMPLETE = 'complete',
  SUBMIT = 'submit',
  HOLD = 'hold', // Not dynamic as the rest actions
  RESUME = 'resume', // Not dynamic as the rest actions
  CONTRIBUTE = 'contribute',
}
